var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWineGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.015 464H192.007V346.75C260.521 330.875 310.032 266.875 303.405 192.625L287.527 14.5C286.777 6.25 279.901 0 271.774 0H48.226C40.1 0 33.223 6.25 32.473 14.5L16.595 192.625C9.968 266.875 59.479 330.875 127.993 346.875V464H87.985C65.855 464 47.976 481.875 47.976 504C47.976 508.375 51.602 512 55.978 512H264.022C268.398 512 272.024 508.375 272.024 504C272.024 481.875 254.145 464 232.015 464ZM77.733 48H242.267L249.394 128H70.606L77.733 48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineGlass);
export default __webpack_public_path__ + "static/media/wine-glass.e8dd145416851966bd31669165126b4c.svg";
export { ForwardRef as ReactComponent };